import { Comment } from "./comment";
import { Step } from "./step";


export class Run{
  runId: string = '';
  projectId: string;
  plates: string[];
  boxes?: string[];
  boxReceptionDate?: Date;
  samples?: any[];
  sender?: string;
  workFlow?: string;
  status?: string;
  processSteps?: Step[];
  comments?: Comment[];
  version?:number;
  labId?: string;
  sampleType?: string;
  machineId?: string;
  line?: string;
  noScanDM?: string;
  processFlowName: string;
  lastModifiedBy: string = "";
  proxyWeatherbyAPI: boolean = false;
}